import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Button, Input, Table } from 'antd';
import axios from 'axios';
import { useState } from 'react';

const SellerApiQuotation = () => {
  const [token, setToken] = useState('');
  const crumbList = [
    { tittle: '외부 api 송출 내역', url: '' },
    { tittle: '외부 api 송출 내역 조회', url: '' }
  ];

  const columns = [
    {
      title: 'NO',
      dataIndex: 'id'
    },
    {
      title: 'Detailed Shipment Information',
      dataIndex: 'shipmentDetail'
    },
    {
      title: 'Shipment Method',
      dataIndex: 'shipmentMethod'
    },
    {
      title: 'Shipment Plan ETD',
      dataIndex: 'shipmentPlanEtd'
    },
    {
      title: 'Shipment Plan ETA',
      dataIndex: 'shipmentPlanEta'
    },
    {
      title: 'Current Checkpoint',
      dataIndex: 'checkPoint'
    },
    {
      title: 'Quotation Status',
      dataIndex: 'progressStatus'
    },
    {
      title: 'Import Status Flag',
      dataIndex: 'isImported'
    },
    {
      title: 'Warehouse Approved Date',
      dataIndex: 'warehouseApprovedDate'
    }
  ];

  const [totalPage, setTotalPage] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState();
  const fetchData = async (page: number) => {
    const res = await axios.get(
      `https://public-api.buskfulfillment.com/api/v1/seller/quotations?page=${page}`,
      {
        headers: {
          'X-Busk-Api-Token': token
        }
      }
    );
    console.log(res.data);
    setTotalPage(res.data.lastPage * 10);
    setData(res.data.data);
  };
  return (
    <div>
      <BreadcrumbList listBreadcrumb={crumbList} />
      <div className="busk-container">
        <div
          style={{
            display: 'flex',
            justifyContent: 'end',
            gap: 20,
            marginBottom: 20
          }}
        >
          <Input
            placeholder="token"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <Button onClick={() => fetchData(0)}>Fetch</Button>
        </div>
        <Table
          pagination={{
            total: totalPage,
            current: currentPage,
            showSizeChanger: false,
            onChange: (page, limit) => {
              fetchData(page - 1);
              setCurrentPage(page);
            }
          }}
          columns={columns}
          dataSource={data}
          scroll={{ x: 'max-content' }}
        />
      </div>
    </div>
  );
};

export default SellerApiQuotation;
